export type SupplierFocus = { supplierId: string; tab: string | null };

// A deep link's supplier and panel tab. The id is not checked here: the server matches nothing for a bad one.
export const readSupplierFocus = (search: string): SupplierFocus | null => {
  const params = new URLSearchParams(search);
  const supplierId = params.get('supplier');
  return supplierId ? { supplierId, tab: params.get('tab') } : null;
};
